<template>
    <main class="login-page">
        <section class="login-layout">
            <aside class="brand-panel">
                <div class="brand-content">
                    <!-- <div class="brand-logo"><q-icon name="storefront" size="34px" /></div> -->

                    <p class="brand-kicker">SERA PAKISTAN</p>
                    <h1>SERA - CRM</h1>
                    <p class="brand-copy">Manage market visits, dealer accounts and follow-ups from one simple
                        workspace.</p>
                </div>
                <div class="brand-footer"><q-icon name="verified_user" /> Secure access for authorised team members
                </div>
            </aside>

            <section class="login-panel">
                <div class="mobile-brand">
                    <!-- <div class="mobile-logo"><q-icon :size="$q.screen.lt.md ? 'md' : ''" name="storefront" /></div>
                    <span>SERA Pakistan</span> -->
                    <div class="row">
                        <img src="../assets/SERA_LOGO.png" />
                    </div>
                </div>
                <div class="login-content">
                    <div class="login-heading">
                        <p class="welcome-note">WELCOME</p>
                        <h2>Sign in to your account</h2>
                        <span>Enter your credentials to continue.</span>
                    </div>
                    <q-form class="login-form" @submit.prevent="handleLogin">
                        <q-input v-model.trim="username" autofocus outlined dense label="Username"
                            :error="isValidation && !username" no-error-icon hide-bottom-space class="formField">
                            <template v-slot:prepend><q-icon color="primary" name="person_outline" /></template>
                        </q-input>
                        <q-input v-model.trim="password" outlined dense :type="isPwd ? 'password' : 'text'"
                            label="Password" :error="isValidation && !password" no-error-icon hide-bottom-space
                            class="formField">
                            <template v-slot:prepend><q-icon color="primary" name="lock_outline" /></template>
                            <template v-slot:append><q-icon :name="isPwd ? 'visibility_off' : 'visibility'"
                                    color="primary" class="cursor-pointer" @click="isPwd = !isPwd" /></template>
                        </q-input>
                        <!-- <p v-if="loginError" class="login-error">{{ loginError }}</p> -->
                        <q-btn type="submit" no-caps label="Sign in" icon-right="arrow_forward" :loading="isLoginLoader"
                            class="sign-in-button" />
                    </q-form>
                    <small class="frgt-pswd-txt" @click="handlePswdReq">Forgot Password?</small>
                    <p class="help-text">Having trouble signing in? Contact your system administrator.</p>
                </div>
                <footer>© {{ new Date().getFullYear() }} SERA Pakistan</footer>
            </section>
        </section>
        <transition name="fade">
            <div v-if="loginError" class="login-error">
                <q-icon name="error_outline" size="18px" />
                <span>{{ loginError }}</span>
            </div>
        </transition>
    </main>
</template>

<script>
    export default {
        name: 'LoginPage',
        data() {
            return { username: '', password: '', isPwd: true, isValidation: false };
        },
        computed: {
            loginError() {
                return this.$store.state.loginError;
            },
            isLoginLoader() {
                return this.$store.state.isLoginLoader;
            },
        },
        methods: {
            handleLogin() {
                if (!this.username || !this.password) {
                    this.isValidation = true;
                    this.warningNotification('Please enter your username and password.');
                    return;
                }
                this.isValidation = false;
                this.$store.commit('loginLoaderHandler', true);
                this.$store.dispatch('authenticatingUser', { UserName: this.username, Password: this.password });
            },

            handlePswdReq() {
                this.$router.push('/forget-password-request-form').catch(() => { })
            },
        },
    };
</script>

<style lang="scss" scoped>
@import '../styles/quasar.scss';

.login-page {
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 18px;
    background: #edf5f6;
    text-align: left;
    box-sizing: border-box;

}

.login-layout {
    width: 100%;
    max-width: 1060px;
    min-height: 680px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    overflow: hidden;
    border-radius: 22px;
    background: #fff;
    box-shadow: 0 20px 55px rgba(13, 76, 92, 0.15);
}

.brand-panel {
    padding: 48px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #fff;
    background: $primary-gradient;
}

.brand-logo,
.mobile-logo {
    display: grid;
    place-items: center;
    border-radius: 14px;
}

.brand-logo {
    width: 62px;
    height: 62px;
    background: rgba(255, 255, 255, 0.14);
}

.brand-kicker {
    margin: 42px 0 8px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.13em;
    opacity: 0.72;
}

.brand-panel h1 {
    margin: 0;
    font-size: 46px;
    line-height: 1.08;
    letter-spacing: -0.03em;
}

.brand-copy {
    max-width: 310px;
    margin: 20px 0 0;
    font-size: 16px;
    line-height: 1.6;
    opacity: 0.82;
}

.brand-footer {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    opacity: 0.72;
}

.login-panel {
    padding: 46px 54px 28px;
    display: flex;
    flex-direction: column;
}

.mobile-brand {
    display: flex;
    align-items: center;
    gap: 9px;
    color: #0d4c5c;
    font-size: 18px;
    font-weight: 800;
}

.login-content {
    width: 100%;
    max-width: 360px;
    margin: auto;
}

.login-heading p {
    margin: 0 0 10px;
    color: #146b80;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.12em;
}

.login-heading h2 {
    margin: 0;
    color: #173e48;
    font-size: 27px;
    line-height: 1.25;
}

.login-heading span {
    display: block;
    margin-top: 9px;
    color: #7a8e93;
    font-size: 14px;
}

.login-form {
    margin-top: 34px;
    display: flex;
    flex-direction: column;
    gap: 19px;
    margin-bottom: 10px;
}

.login-form :deep(.q-field__control) {
    min-height: 48px;
}

.login-form :deep(.q-field--outlined .q-field__control:before) {
    border-color: #cbd9dc;
}

.login-form :deep(.q-field--focused .q-field__control:after) {
    border-color: #146b80;
}

.login-form :deep(.q-field__label),
.login-form :deep(.q-field__native) {
    color: #426068;
}

.login-error {
    margin: -7px 0 0;
    color: #c83c3c;
    font-size: 12px;
}

.sign-in-button {
    min-height: 48px;
    margin-top: 3px;
    color: #fff;
    border-radius: 8px;
    background: $primary-gradient;
}

.sign-in-button .q-icon {
    color: white !important;
}

.help-text {
    margin: 24px 0 0;
    color: #819499;
    font-size: 12px;
    text-align: center;
}

.login-panel footer {
    color: #99aaae;
    font-size: 11px;
    text-align: center;
}

.login-form :deep(.q-icon) {
    color: #fff;
}

.welcome-note {
    color: $magenta !important;
}

@media (max-width: 720px) {
    .login-page {
        padding: 0;
        align-items: stretch;
        position: relative;
    }

    .login-layout {
        min-height: 100vh;
        grid-template-columns: 1fr;
        border-radius: 0;
        box-shadow: none;
    }

    .brand-panel {
        display: none;
    }

    .login-panel {
        padding: 28px 24px 22px;
    }

    .mobile-brand {
        display: flex;
        align-items: center;
        gap: 9px;
        color: #0d4c5c;
        font-size: 18px;
        font-weight: 800;
    }

    .mobile-logo {
        width: 40px;
        height: 40px;
        color: #fff;
        background: $primary;
    }

    .login-content {
        margin: auto 0;
        margin-top: 120px;
    }

    .login-heading h2 {
        font-size: 28px;
    }

    .login-form {
        margin-top: 30px;
    }

    .login-panel footer {
        margin-top: 24px;
    }

    .formField {
        min-height: 60px;
    }

    .formField :deep(.q-field__control) {
        height: 60px;
        min-height: 60px;
    }

    .formField :deep(.q-field__native) {
        min-height: 60px !important;
    }

    .login-error {
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translateX(-50%);
    }
}

@media (max-width: 360px) {
    .login-panel {
        padding-right: 18px;
        padding-left: 18px;
    }

    .login-heading h2 {
        font-size: 25px;
    }

    .formField {
        min-height: 60px;
    }

    .formField :deep(.q-field__control) {
        height: 60px;
        min-height: 60px;
    }

    .formField :deep(.q-field__native) {
        min-height: 60px;
    }

    .login-error {
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translateX(-50%);
    }


}

.frgt-pswd-txt {
    color: $primary;
    cursor: pointer;
    font-weight: 700;
    margin-left: 16px;

}

.login-error {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 12px;
    padding: 10px 12px;
    color: #c62828;
    background: #fdecea;
    border: 1px solid #f5c2c0;
    border-radius: 8px;
    font-size: 13px;
    line-height: 1.4;

    .q-icon {
        flex: 0 0 auto;
        color: #c62828;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
